module.exports = {
  "core.HBNBVersion": {
    "params": [],
    "memberof": "core",
    "name": "HBNBVersion",
    "return": "Promise"
  },
  "core.OS": {
    "params": [],
    "memberof": "core",
    "name": "OS",
    "return": "Promise"
  },
  "core.supportApis": {
    "params": [],
    "memberof": "core",
    "name": "supportApis",
    "return": "Promise"
  },
  "account.getUser": {
    "params": [],
    "memberof": "account",
    "name": "getUser",
    "return": "Promise"
  },
  "account.login": {
    "params": [],
    "memberof": "account",
    "name": "login",
    "return": "Promise"
  },
  "account.mobileLogin": {
    "params": [
      "mobile",
      "code"
    ],
    "memberof": "account",
    "name": "mobileLogin",
    "return": "Promise"
  },
  "account.sendMobileLoginCode": {
    "params": [
      "mobile"
    ],
    "memberof": "account",
    "name": "sendMobileLoginCode",
    "return": "Promise"
  },
  "log.mge": {
    "params": [
      "cid",
      "act",
      "val",
      "lab"
    ],
    "memberof": "log",
    "name": "mge",
    "return": "Undefined"
  },
  "network.request": {
    "params": [
      "opts"
    ],
    "memberof": "network",
    "name": "request",
    "return": "Promise"
  },
  "network.sendSms": {
    "params": [],
    "memberof": "network",
    "name": "sendSms"
  },
  "pay.getFingerprint": {
    "params": [],
    "memberof": "pay",
    "name": "getFingerprint",
    "return": "Promise"
  },
  "pay.payment": {
    "params": [
      "opts"
    ],
    "memberof": "pay",
    "name": "payment",
    "return": "Promise"
  },
  "position.getCity": {
    "params": [],
    "memberof": "position",
    "name": "getCity",
    "return": "Promise"
  },
  "storage.getItem": {
    "params": [],
    "memberof": "storage",
    "name": "getItem",
    "return": "Promise"
  },
  "storage.removeItem": {
    "params": [],
    "memberof": "storage",
    "name": "removeItem",
    "return": "Undefined"
  },
  "storage.setItem": {
    "params": [],
    "memberof": "storage",
    "name": "setItem",
    "return": "Undefined"
  },
  "storage.setResult": {
    "params": [
      "obj"
    ],
    "memberof": "storage",
    "name": "setResult",
    "return": "Undefined"
  },
  "thirdApps.installed": {
    "params": [
      "appName"
    ],
    "memberof": "thirdApps",
    "name": "installed",
    "return": "Promise"
  },
  "ui.alert": {
    "params": [
      "message",
      "title",
      "button"
    ],
    "memberof": "ui",
    "name": "alert",
    "return": "Undefined"
  },
  "ui.autoLock": {
    "params": [
      "enable"
    ],
    "memberof": "ui",
    "name": "autoLock",
    "return": "Undefined"
  },
  "ui.confirm": {
    "params": [
      "message",
      "title",
      "leftButton",
      "rightButton"
    ],
    "memberof": "ui",
    "name": "confirm",
    "return": "Undefined"
  },
  "ui.loadingStart": {
    "params": [],
    "memberof": "ui",
    "name": "loadingStart",
    "return": "Undefined"
  },
  "ui.loadingStop": {
    "params": [],
    "memberof": "ui",
    "name": "loadingStop",
    "return": "Undefined"
  },
  "ui.options": {
    "params": [
      "menus",
      "cancel"
    ],
    "memberof": "ui",
    "name": "options",
    "return": "Undefined"
  },
  "ui.selectDate": {
    "params": [
      "current",
      "maxDate",
      "minDate"
    ],
    "memberof": "ui",
    "name": "selectDate",
    "return": "Promise"
  },
  "ui.singleSelect": {
    "params": [
      "menus"
    ],
    "memberof": "ui",
    "name": "singleSelect",
    "return": "Undefined"
  },
  "ui.toast": {
    "params": [
      "message",
      "time"
    ],
    "memberof": "ui",
    "name": "toast",
    "return": "Undefined"
  },
  "webview.back": {
    "params": [],
    "memberof": "webview",
    "name": "back",
    "return": "Undefined"
  },
  "webview.closeAll": {
    "params": [
      "urls"
    ],
    "memberof": "webview",
    "name": "closeAll",
    "return": "Undefined"
  },
  "webview.close": {
    "params": [],
    "memberof": "webview",
    "name": "close",
    "return": "Undefined"
  },
  "webview.dismiss": {
    "params": [],
    "memberof": "webview",
    "name": "dismiss"
  },
  "webview.modal": {
    "params": [
      "url"
    ],
    "memberof": "webview",
    "name": "modal",
    "return": "Undefined"
  },
  "webview.open": {
    "params": [
      "url"
    ],
    "memberof": "webview",
    "name": "open",
    "return": "Undefined"
  },
  "webview.setBackAction": {
    "params": [
      "cb"
    ],
    "memberof": "webview",
    "name": "setBackAction",
    "return": "Undefined"
  },
  "webview.setComplexTitle": {
    "params": [
      "opts"
    ],
    "memberof": "webview",
    "name": "setComplexTitle",
    "return": "Undefined"
  },
  "webview.setMenus": {
    "params": [
      "menus"
    ],
    "memberof": "webview",
    "name": "setMenus",
    "return": "Undefined"
  },
  "webview.setTitle": {
    "params": [
      "title"
    ],
    "memberof": "webview",
    "name": "setTitle",
    "return": "Undefined"
  },
  "tower.sendTopicCommentSuccess": {
    "params": [],
    "memberof": "tower",
    "name": "sendTopicCommentSuccess",
    "return": "Promise"
  },
  "tower.comment": {
    "params": [
      "opts"
    ],
    "memberof": "tower",
    "name": "comment",
    "return": "Promise"
  },
  "tower.getUuid": {
    "params": [],
    "memberof": "tower",
    "name": "getUuid",
    "return": "Promise"
  },
  "tower.shareConfig": {
    "params": [
      "name",
      "opts"
    ],
    "memberof": "tower",
    "name": "shareConfig",
    "return": "Promise"
  },
  "tower.checkNickname": {
    "params": [],
    "memberof": "tower",
    "name": "checkNickname",
    "return": "Promise"
  },
  "flight.alipay": {
    "params": [
      "orderId",
      "payURL",
      "returnURL"
    ],
    "memberof": "flight",
    "name": "alipay",
    "return": "Promise"
  },
  "flight.getExpress": {
    "params": [
      "siteId",
      "id"
    ],
    "memberof": "flight",
    "name": "getExpress",
    "return": "Promise"
  },
  "flight.getFilter": {
    "params": [
      "opts"
    ],
    "memberof": "flight",
    "name": "getFilter",
    "return": "Promise"
  },
  "flight.getLinkman": {
    "params": [
      "id"
    ],
    "memberof": "flight",
    "name": "getLinkman",
    "return": "Promise"
  },
  "flight.getUser": {
    "params": [],
    "memberof": "flight",
    "name": "getUser",
    "return": "Promise"
  },
  "flight.gotoAppHomepage": {
    "params": [],
    "memberof": "flight",
    "name": "gotoAppHomepage",
    "return": "Undefined"
  },
  "flight.gotoOrderDetail": {
    "params": [
      "url",
      "orderListUrl"
    ],
    "memberof": "flight",
    "name": "gotoOrderDetail",
    "return": "Undefined"
  },
  "flight.login": {
    "params": [],
    "memberof": "flight",
    "name": "login",
    "return": "Promise"
  },
  "flight.selectCity": {
    "params": [
      "city"
    ],
    "memberof": "flight",
    "name": "selectCity",
    "return": "Promise"
  },
  "flight.selectDate": {
    "params": [
      "fromCity",
      "toCity",
      "months",
      "original"
    ],
    "memberof": "flight",
    "name": "selectDate",
    "return": "Promise"
  },
  "flight.selectRoundDate": {
    "params": [],
    "memberof": "flight",
    "name": "selectRoundDate",
    "return": "Promise"
  },
  "train.gotoOrderDetail": {
    "params": [
      "url",
      "orderListUrl"
    ],
    "memberof": "train",
    "name": "gotoOrderDetail",
    "return": "Undefined"
  },
  "train.gotoOrderList": {
    "params": [
      "url"
    ],
    "memberof": "train",
    "name": "gotoOrderList",
    "return": "Undefined"
  },
  "train.multiSelect": {
    "params": [
      "menus"
    ],
    "memberof": "train",
    "name": "multiSelect",
    "return": "Promise"
  },
  "train.ringtone": {
    "params": [
      "loop"
    ],
    "memberof": "train",
    "name": "ringtone",
    "return": "Promise"
  },
  "train.selectDateRush": {
    "params": [
      "opts"
    ],
    "memberof": "train",
    "name": "selectDateRush",
    "return": "Promise"
  },
  "train.selectDateStudent": {
    "params": [
      "opts"
    ],
    "memberof": "train",
    "name": "selectDateStudent",
    "return": "Promise"
  },
  "train.selectDate": {
    "params": [
      "date",
      "days",
      "tips"
    ],
    "memberof": "train",
    "name": "selectDate",
    "return": "Promise"
  },
  "train.selectStation": {
    "params": [
      "stationCode",
      "stationType"
    ],
    "memberof": "train",
    "name": "selectStation",
    "return": "Promise"
  },
  "train.selectTrains": {
    "params": [
      "menus"
    ],
    "memberof": "train",
    "name": "selectTrains",
    "return": "Promise"
  },
  "train.timeRange": {
    "params": [
      "start",
      "end"
    ],
    "memberof": "train",
    "name": "timeRange",
    "return": "Promise"
  },
  "train.timeTable": {
    "params": [
      "stations"
    ],
    "memberof": "train",
    "name": "timeTable",
    "return": "Undefined"
  },
  "train.vibrate": {
    "params": [
      "duration"
    ],
    "memberof": "train",
    "name": "vibrate",
    "return": "Promise"
  },
  "inject.addStopUrl": {
    "params": [
      "name",
      "pattern",
      "script"
    ],
    "memberof": "inject",
    "name": "addStopUrl",
    "return": "Promise"
  },
  "inject.callback": {
    "params": [
      "fnName",
      "data"
    ],
    "memberof": "inject",
    "name": "callback",
    "return": "Undefined"
  },
  "inject.close": {
    "params": [
      "name"
    ],
    "memberof": "inject",
    "name": "close",
    "return": "Promise"
  },
  "inject.loadHTML": {
    "params": [
      "name",
      "url",
      "html"
    ],
    "memberof": "inject",
    "name": "loadHTML",
    "return": "Promise"
  },
  "inject.load": {
    "params": [
      "name",
      "url"
    ],
    "memberof": "inject",
    "name": "load",
    "return": "Promise"
  },
  "inject.runScript": {
    "params": [
      "name",
      "script",
      "param"
    ],
    "memberof": "inject",
    "name": "runScript",
    "return": "Promise"
  },
  "inject.show": {
    "params": [
      "name"
    ],
    "memberof": "inject",
    "name": "show",
    "return": "Promise"
  },
  "travel.getPosDeviceId": {
    "params": [],
    "memberof": "travel",
    "name": "getPosDeviceId",
    "return": "Promise"
  },
  "travel.print": {
    "params": [
      "content"
    ],
    "memberof": "travel",
    "name": "print",
    "return": "Promise"
  },
  "travel.check_printer_state": {
    "params": [],
    "memberof": "travel",
    "name": "check_printer_state",
    "return": "Promise"
  },
  "travel.selectCity": {
    "params": [
      "city"
    ],
    "memberof": "travel",
    "name": "selectCity",
    "return": "Promise"
  },
  "travel.setGdata": {
    "params": [
      "bigG"
    ],
    "memberof": "travel",
    "name": "setGdata",
    "return": "Promise"
  },
  "env.getPageEnv": {
    "params": [],
    "memberof": "env",
    "name": "getPageEnv",
    "return": "Promise"
  },
  "share.activeNavButton": {
    "params": [
      "channel",
      "conf"
    ],
    "memberof": "share",
    "name": "activeNavButton",
    "return": "Undefined"
  },
  "share.callLocal": {
    "params": [
      "channel",
      "conf"
    ],
    "memberof": "share",
    "name": "callLocal",
    "return": "Undefined"
  },
  "share.disableNavButton": {
    "params": [],
    "memberof": "share",
    "name": "disableNavButton",
    "return": "Undefined"
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/hbnb/uncommon-apis.js
// module id = 173
// module chunks = 10 11 12 13 14 15 16 17 18 19